import Vue from 'vue'

// 配置路由
import VueRouter from 'vue-router'
Vue.use(VueRouter)

//API接口
import Api from '../utils/api.js';
Vue.prototype.$api = Api;

//请求方法
import Request from '../utils/request.js';
Vue.prototype.$request = Request;

//时间戳转换
import timestamp from '../utils/timestamp.js';
Vue.prototype.$timestamp = timestamp;

//配置参数
import Config from '../utils/config.js';
Vue.prototype.$config = Config;

//axios
import axios from 'axios';
Vue.prototype.$axios = axios;

//路由跳转
import Jump from '../utils/jump.js';
Vue.prototype.$jump = Jump;

//YDUI
import YDUI from 'vue-ydui';
import 'vue-ydui/dist/ydui.rem.css';
Vue.use(YDUI);

//本地存储
import Storage from '../utils/storage.js';
Vue.prototype.$storage = Storage;

//element UI的css 和 插件
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '../assets/element/theme/index.css';//自定义主题
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });


// 创建单页面
import Index from '../page/Index';//首页
import logIn from '../page/logIn';//登录
import supplier from '../page/supplier';//选择供应商
import enterprise from '../page/enterprise';//企业概况
import factory from '../page/factory';//工厂概况
import product from '../page/product';//产品概况
import submit from '../page/submit';//提交
import knowledge from '../page/knowledge';//知识产权调查表
import safety from '../page/safety';//信息安全调查表
import accessory from '../page/accessory';//附件
import Protestantism from '../page/Protestantism';//新
const routes = [
    {path:'/Index',name:'Index',component:Index},//首页
    {path:'/logIn',name:'logIn',component:logIn},//登录
    {path:'/supplier',name:'supplier',component:supplier},//选择供应商
    {path:'/enterprise',name:'enterprise',component:enterprise},//企业概况
    {path:'/factory',name:'factory',component:factory},//工厂概况
    {path:'/product',name:'product',component:product},//产品概况
    {path:'/submit',name:'submit',component:submit},//提交
    {path:'/knowledge',name:'knowledge',component:knowledge},//知识产权调查表
    {path:'/safety',name:'safety',component:safety},//信息安全调查表
    {path:'/accessory',name:'accessory',component:accessory},//附件
    {path:'/Protestantism',name:'Protestantism',component:Protestantism},//新
    {path:'/',redirect:'/Protestantism'},
]

// 实例化
const router = new VueRouter({
    routes,

    // 异步滚动
    scrollBehavior(to,from,savedPosition){
        if(savedPosition){
            return savedPosition
        }else{
            return{ x:0,y:0}
        }
    }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/routes.js